// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.2_esbuild@0.25.9_postcss@8.5.6_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.2_esbuild@0.25.9_postcss@8.5.6_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cursor-pointer {
  cursor: pointer;
}

.list-group .list-group-item.category-item {
  border: none;
  padding: 12px 0;
  transition: all 0.2s ease;
}
.list-group .list-group-item.category-item:hover {
  background-color: transparent;
  color: var(--secondary);
  padding-left: 4px;
}
.list-group .list-group-item.category-item.active-category {
  background-color: transparent;
  color: var(--secondary);
  font-weight: 500;
}
.list-group .list-group-item.category-item.active-category:hover {
  background-color: transparent;
  color: var(--secondary);
}

.list-group-flush > .list-group-item {
  border-right: none;
  border-left: none;
}
.list-group-flush > .list-group-item:first-child {
  border-top: none;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom: none;
}

.brand-model-header {
  transition: all 0.2s ease;
}
.brand-model-header:hover {
  opacity: 0.8;
}

.fa-chevron-up,
.fa-chevron-down {
  transition: transform 0.2s ease;
}`, "",{"version":3,"sources":["webpack://./src/app/components/selection-page/selection-page.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;AADJ;;AAKI;EACI,YAAA;EACA,eAAA;EACA,yBAAA;AAFR;AAIQ;EACI,6BAAA;EACA,uBAAA;EACA,iBAAA;AAFZ;AAKQ;EACI,6BAAA;EACA,uBAAA;EACA,gBAAA;AAHZ;AAKY;EACI,6BAAA;EACA,uBAAA;AAHhB;;AASA;EACI,kBAAA;EACA,iBAAA;AANJ;AAQI;EACI,gBAAA;AANR;AASI;EACI,mBAAA;AAPR;;AAYA;EACI,yBAAA;AATJ;AAWI;EACI,YAAA;AATR;;AAcA;;EAEI,+BAAA;AAXJ","sourcesContent":["// Selection Page Styles\n\n.cursor-pointer {\n    cursor: pointer;\n}\n\n.list-group .list-group-item {\n    &.category-item {\n        border: none;\n        padding: 12px 0;\n        transition: all 0.2s ease;\n\n        &:hover {\n            background-color: transparent;\n            color: var(--secondary);\n            padding-left: 4px;\n        }\n\n        &.active-category {\n            background-color: transparent;\n            color: var(--secondary);\n            font-weight: 500;\n\n            &:hover {\n                background-color: transparent;\n                color: var(--secondary);\n            }\n        }\n    }\n}\n\n.list-group-flush > .list-group-item {\n    border-right: none;\n    border-left: none;\n    \n    &:first-child {\n        border-top: none;\n    }\n    \n    &:last-child {\n        border-bottom: none;\n    }\n}\n\n// Brand/Model header toggle\n.brand-model-header {\n    transition: all 0.2s ease;\n    \n    &:hover {\n        opacity: 0.8;\n    }\n}\n\n// Chevron animation\n.fa-chevron-up,\n.fa-chevron-down {\n    transition: transform 0.2s ease;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
